import * as Table from '../Table';
import styles from './styles/Draggable.module.css';

type Props = {
  value: string;
};

export const Cell = (props: Props) => {
  return <Table.Body.TD className={styles.title}>{props.value || 'N/A'}</Table.Body.TD>;
};

Cell.displayName = 'Column.Status.Cell';

export const Header = (props: unknown) => {
  return <Table.Header.TH className={styles.title}>Tag Status</Table.Header.TH>;
};

Header.displayName = 'Column.Status.Header';
